// overview/* page translations
const overview = {
  enterpriseFactory: {
    v2: {
      breadcrumbRoot: 'Toàn công ty',
      refresh: 'Làm mới',
      retry: 'Thử lại',
      loadFailed: 'Không tải được tình trạng nhà máy',
      loading: 'Đang tải...',
      empty: 'Chưa có nhà máy',
      unitMachine: 'máy',
      unitCase: '',
      unitCount: '',
      level: {
        good: 'Bình thường',
        warn: 'Cảnh báo',
        bad: 'Nguy hiểm',
      },
      status: {
        running: 'Chạy',
        idle: 'Chờ',
        stopped: 'Dừng',
        partial: 'Dừng một phần',
        none: 'Không có máy',
      },
      kpi: {
        equipment: 'Tổng số máy',
        rate: 'Tỷ lệ vận hành chung',
        rateSub: 'Chạy {r} · Chờ {i} · Dừng {s}',
        alarms: 'Tổng cảnh báo',
        alarmSub: 'Nguy hiểm {c} · Cảnh báo {w} · Thông tin {i}',
        production: 'Tổng sản lượng (hôm nay)',
        productionSub: 'Đơn vị: shot',
      },
      openFactory: 'Mở tình trạng nhà máy',
      runShare: 'Tỷ lệ máy chạy',
      legend: {
        running: 'Chạy',
        idle: 'Chờ',
        stopped: 'Dừng',
      },
      rate: 'Vận hành',
      equipment: 'Số máy',
      openAlarms: 'Cảnh báo chưa xử lý',
      machinesTitle: 'Tình trạng thiết bị',
      noMachines: 'Chưa có thiết bị',
      moldNo: 'Số khuôn',
      shotCount: 'Số shot',
      cav: 'CAV', // 캐비티 수 — 현장 약어 그대로
      ct: 'C/T', // 사이클 타임 — 현장 약어 그대로
      alarmCount: '{n} cảnh báo',
      cycle: 'Chu kỳ',
      alarmsTitle: 'Cảnh báo thời gian thực',
      filter: {
        all: 'Tất cả',
        error: 'Nguy hiểm',
        warning: 'Cảnh báo',
      },
      noAlarms: 'Không có cảnh báo đang diễn ra.',
      repeat: '{n} lần trong 24h · {time}',
    },
  },
  factoryDefect: {
    breadcrumbRoot: 'Toàn công ty',
    pageLabel: 'Lịch sử lỗi',
    panelTitle: 'Lịch sử lỗi nhà máy · {n} máy',
    refresh: 'Làm mới',
    loadingData: 'Đang tải...',
    loadFailed: 'Không tải được lịch sử lỗi',
    factoryListLoadFailed: 'Không tải được danh sách nhà máy',
    period: 'Kỳ',
    periods: { today: 'Hôm nay', yesterday: 'Hôm qua', last24h: '24 giờ qua', last48h: '2 ngày qua' },
    source: 'Tiêu chí',
    sources: { fusion: 'Kiểm tra hợp nhất', vision: 'Kiểm tra hình ảnh', process: 'Kiểm tra quy trình' },
    equipment: 'Máy',
    type: 'Loại',
    all: 'Tất cả',
    allEquipment: 'Tất cả máy',
    retentionNote: 'Shot và kết quả được lưu 2 ngày',
    kpi: { inspected: 'Đã kiểm tra', ng: 'Lỗi', ngRate: 'Tỷ lệ lỗi', topType: 'Loại nhiều nhất', topEquipment: 'Máy lỗi nhiều nhất' },
    countN: '{n}',
    matrixTitle: 'Máy × loại lỗi',
    matrixSub: '{n} / {total} máy có kết quả · nhấp ô để lọc',
    trendTitleHour: 'Lỗi theo giờ',
    trendTitleDay: 'Lỗi theo ngày',
    noTrend: 'Không có kết quả trong kỳ này',
    listTitle: 'Danh sách lỗi',
    rowHint: 'Mở màn hình Chất lượng · Sản xuất của máy này',
    empty: 'Không có kết quả trong kỳ này',
    emptyFiltered: 'Không có lỗi phù hợp',
    colEquipment: 'Máy',
    colTotal: 'Tổng',
    colRate: 'Tỷ lệ',
    colTime: 'Thời điểm',
    colMold: 'Khuôn',
    colShot: 'Shot',
    colType: 'Loại',
    colProcess: 'Điểm quy trình',
    colVision: 'Điểm hình ảnh',
    colFusion: 'Điểm hợp nhất',
    colImage: 'Ảnh',
    types: { FLASH: 'Bavia', WELDLINE: 'Đường hàn', SHORT: 'Thiếu nhựa', SINK: 'Lõm co', PROCESS: 'Do quy trình', UNKNOWN: 'Khác' },
    prev: 'Trước',
    next: 'Sau',
  },
  factoryMachine: {
    breadcrumbRoot: 'Toàn công ty',
    pageLabel: 'Tình trạng máy ép',
    panelTitle: 'Máy ép trong nhà máy · {n} máy',
    cards: {
      line: 'Dây chuyền',
      state: 'Trạng thái',
      sort: 'Sắp xếp',
      alarmOnly: 'Cảnh báo',
      moldNo: 'Số khuôn',
      shotCount: 'Số shot',
      cav: 'CAV', // 캐비티 수 — 현장 약어 그대로
      ct: 'C/T', // 사이클 타임 — 현장 약어 그대로
      utilization: 'Tỷ lệ vận hành',
      cycleTime: 'Chu kỳ',
      alarmCount: '{n} cảnh báo',
      sort_utilization: 'Tỷ lệ vận hành↓',
      sort_number: 'Theo số',
      sort_shot: 'Số shot↓',
      sort_alarm: 'Ưu tiên cảnh báo',
    },
    title: 'Bảng điều khiển máy',
    subtitle: 'Trạng thái máy ép phun trong nhà máy',
    update: 'Cập nhật',
    loading: 'Đang tải...',
    loadingData: 'Đang tải dữ liệu...',
    loadFailed: 'Không thể tải dữ liệu.',
    factoryListLoadFailed: 'Không thể tải danh sách nhà máy.',
    refresh: 'Làm mới',
    emptyMachines: 'Chưa có máy nào được đăng ký.',
    selectFactory: 'Chọn nhà máy',
    all: 'Tất cả',
    machine: {
      productName: 'Sản phẩm',
      shotCount: 'Số lần phun',
      cavityCount: 'Khoang khuôn',
      cycleTime: 'Thời gian chu kỳ',
      utilizationLabel: 'Tỷ lệ vận hành 24h',
      timelineTitle: 'Trạng thái vận hành 24h',
      cavityUnit: '{n}',
      cycleTimeUnit: '{n}s',
      empty: '-',
    },
    legend: {
      operating: 'Hoạt động',
      standby: 'Chờ',
      stopped: 'Dừng',
    },
    status: {
      running: 'Đang chạy',
      idle: 'Chờ',
      stopped: 'Dừng',
      error: 'Lỗi',
    },
  },
};
export default overview;
